;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import Link from 'components/ui/Link';
import SvgIcon from 'components/ui/SvgIcon';

import styles from './SocialLink.module.scss';

const SocialLink = ({ href, platform }) => {
    return (
        <Link className={styles.root} href={href}>
            <SvgIcon className={styles[platform]} type={platform} />
            <span className="sr-only">{platform}</span>
        </Link>
    );
};

SocialLink.propTypes = {
    href: PropTypes.string.isRequired,
    platform: PropTypes.string.isRequired,
};

export default SocialLink;
